"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function StandardsTable() {
  const { currentLang, t } = useLanguage();
  const isEs = currentLang === "es";

  const rows = isEs
    ? [
        { zone: "HVHZ", wind: "175 mph", missile: "Grande + Pequeño (TAS 201)", coverage: "Miami-Dade, Broward" },
        { zone: "WBDR", wind: "140 mph", missile: "Solo pequeño", coverage: "Costa a 1 milla tierra adentro en todo el estado" },
        { zone: "Estándar", wind: "130 mph", missile: "No requerido", coverage: "Interior de Florida" },
        { zone: "Internacional", wind: "Variable", missile: "No requerido", coverage: "Fuera de Florida" },
      ]
    : [
        { zone: "HVHZ", wind: "175 mph", missile: "Large + Small (TAS 201)", coverage: "Miami-Dade, Broward" },
        { zone: "WBDR", wind: "140 mph", missile: "Small only", coverage: "Coastal 1mi inland statewide" },
        { zone: "Standard", wind: "130 mph", missile: "Not required", coverage: "Interior Florida" },
        { zone: "International", wind: "Varies", missile: "Not required", coverage: "Outside Florida" },
      ];

  const headers = isEs
    ? ["Estándar", "Vel. Viento de Diseño", "Prueba de Misil", "Área de Cobertura"]
    : ["Standard", "Design Wind Speed", "Missile Test", "Coverage Area"];

  return (
    <section className="bg-[#fefce8] py-12 max-w-4xl mx-auto">
      <h2 className="text-3xl font-bold text-[#064e3b] mb-6 text-center">
        {t("blog.codes.tableTitle")}
      </h2>
      <div className="overflow-x-auto rounded-lg border border-[#064e3b]/10">
        <table className="w-full text-sm">
          <thead>
            <tr className="bg-[#064e3b] text-white">
              {headers.map((h) => (
                <th key={h} className="px-5 py-3 text-left font-semibold">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={row.zone} className={i % 2 === 0 ? "bg-white" : "bg-[#fefce8]"}>
                <td className="px-5 py-4 font-bold text-[#064e3b]">{row.zone}</td>
                <td className="px-5 py-4 text-gray-700">{row.wind}</td>
                <td className="px-5 py-4 text-gray-700">{row.missile}</td>
                <td className="px-5 py-4 text-gray-700">{row.coverage}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}